import { Box, Button, Chip, Grid, Pagination, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { ApiCreateChecklistSubmission, ApiGetVenueManagerChecklistList } from '../../apiService/Core/Apicall';
import storage from '../../utils/storage';
import { toast } from 'react-toastify';

const statusStyles: any = {
    // "duesoon": {
    //     border: "#BF613B",
    //     bg: "#BF613B1A",
    //     badgeBg: "#FDE6DD",
    //     color: "#BF613B",
    // },
    "pending": {
        border: "#F96E09",
        bg: "#FFBF441A",
        badgeBg: "#FFBF441A",
        color: "#F96E09",
    },
    "overdue":{
        border: "#BF613B",
        bg: "#BF613B1A",
        badgeBg: "#FDE6DD",
        color: "#BF613B",
    },
    "draft": {
        border: "var(--primary-color)",
        bg: "var(--primary-light-main-color)",
        badgeBg: "var(--primary-light-main-color)",
        color: "var(--primary-color)",
    },
    "duesoon": {
        border: "#7C9FB2",
        bg: "#7C9FB21A",
        badgeBg: "#E5F0F5",
        color: "#7C9FB2",
    },
};

function VenueChecklistList({ venues, month }: any) {
    const [checklistData1, setChecklistData] = useState<any>([])
    const userData = JSON.parse(storage.getItem("userData") || "{}");
    const [page, setPage] = useState(1);
    const rowsPerPage = 5;
    const totalPages = Math.ceil(checklistData1.length / rowsPerPage);
    const paginatedData = checklistData1.slice(
        (page - 1) * rowsPerPage,
        page * rowsPerPage
    );

    const navigate = useNavigate()

    const getVenueManagerChecklist = async () => {
        try {
            const checkListType = storage.getItem('dashboardCheckListType') || "BUSINESS";
            const isAreaManager = checkListType === "AREA_MANAGER";
            const data = `?clientEntityId=${storage.getItem("clientEntityId")}${isAreaManager ? `&areaId=${storage.getItem("areaId")}` : `&venueId=${venues}`}&userId=${userData?.userId}&month=${month?.month() + 1}&year=${month?.year()}&todayDate=${new Date().toISOString().split("T")[0]}&checkListType=${checkListType}`
            const res = await ApiGetVenueManagerChecklistList(data)
            if (res?.status || res?.success) {
                setChecklistData(res?.data)
            }
        } catch (error: any) {
            toast.error(error)
        }
    }
    useEffect(() => {
        getVenueManagerChecklist()
    }, [venues, month])

    const createCehcklistSubmission = async (item: any) => {
        try {
            const data = {
                "businessCheckListSubmissionId": item?.businessCheckListSubmissionId,
                "userId": userData?.userId
            }
            const res = await ApiCreateChecklistSubmission(data)
            if (res?.status || res?.success) {
                return
            }
        } catch (error: any) {
            toast.error(error)
        }
    }
    const openChecklistDetails = async (item: any) => {
        if (item?.status === "CREATED") {
            await createCehcklistSubmission(item)
        }
        navigate(`/maindashboard/checklist/checklist-list/checklist-questions/${item?.businessCheckListSubmissionId}`)
    }

    return checklistData1?.length > 0 ?
        (
            <Grid container spacing={2} flex={1} className='pt-3 d-flex h-100  flex-column'>
                <Grid size={12} flex={1} >
                    <Grid container  spacing={1}>
                        {paginatedData.map((item: any) => {
                            const style =
                                statusStyles[item.statusTitle.toLowerCase().replace(/\s/g, "")] ||
                                statusStyles.pending;

                            return (
                                <Grid size={{ xs: 12 }} key={item.id}>
                                    <Box
                                        className='border' // onClick={() => { navigate('/maindashboard/checklist/checklist-list/checklist-questions') }}
                                        sx={{
                                            py: 1,
                                            px: 2,
                                            borderRadius: 1,
                                            // border: `1px solid ${style.border}`,
                                            // bgcolor: style.bg,
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: 'center',
                                            transition: ".25s",
                                            position:"relative",
                                            borderLeft:`3px solid ${style.border} !important`,
                                            // "::before":{
                                            //     position:'absolute',
                                            //     height:'100%',
                                            // },
                                            "&:hover": {
                                                transform: "translateY(-2px)",
                                            },
                                        }}
                                    >
                                        <Box>
                                            <Box className='d-flex align-items-center gap-2 mb-1'>
                                                {/* <Chip
                                                    label={item.statusTitle}
                                                    sx={{
                                                        bgcolor: style.badgeBg,
                                                        color: style.color,
                                                        // fontWeight: 700,
                                                        borderRadius:"5px",
                                                        padding:'0px 8px',
                                                        border:"1px solid var(--primary-color)"
                                                    }}
                                                /> */}
                                                <Typography variant='caption' sx={{bgcolor: style.badgeBg,borderRadius:"5px", py:0, px:"8px", lineHeight:'normal', border:`1px solid ${style.color}`}}>{item.statusTitle}</Typography>
                                                 <Typography variant="caption">
                                                    {item?.scheduleType === "DAILY" ?"Daily" : "Interval_Days"}
                                                </Typography>
                                            </Box>
                                            <Typography variant='body2' fontWeight={700}>{item?.businessCheckListTitle}</Typography>

                                        </Box>
                                        {item?.statusTitle !== "Completed" ? (
                                            <Button
                                                // variant="outlined"
                                                // className='btn-main'
                                                onClick={() => { openChecklistDetails(item) }}
                                                sx={{
                                                    // mt: 2,
                                                    borderColor: style.border,
                                                    color: "white",
                                                    background:style.color,
                                                    // borderRadius: "30px",
                                                    textTransform: "none",
                                                    "&:hover": {
                                                        bgcolor: style.border,
                                                        color: "#fff",
                                                        borderColor: style.border,
                                                    },
                                                }}
                                            >
                                                Start
                                            </Button>
                                        ) : (
                                            <Button
                                                variant="outlined"
                                                disabled
                                                sx={{
                                                    mt: 2,
                                                    borderColor: style.border,
                                                    color: style.color,
                                                    borderRadius: "30px",
                                                    textTransform: "none",
                                                    "&:hover": {
                                                        bgcolor: style.border,
                                                        color: "#fff",
                                                        borderColor: style.border,
                                                    },
                                                }}
                                            >
                                                Submitted
                                            </Button>
                                        )}
                                    </Box>
                                </Grid>
                            );
                        })}
                    </Grid>
                </Grid>
                <Grid size={12}>
                    {totalPages > 1 && (
                        <Box display="flex" justifyContent="center" mt={2}>
                            <Pagination
                                page={page}
                                sx={{
                                    "& .MuiPaginationItem-root.Mui-selected": {
                                        backgroundColor: 'var(--primary-color)'
                                    }
                                }}
                                count={totalPages}
                                color="primary"
                                onChange={(_, value) => setPage(value)}
                            />
                        </Box>
                    )}
                </Grid>
            </Grid>
        ) : (
            <Box className='d-flex align-items-center justify-content-center' sx={{ minHeight: '200px', height: '100%', width: '100%' }} flex={1}>
                <Typography>No Data Found</Typography>
            </Box>
        )
}

export default VenueChecklistList
